import axios from "../../Shared/auth-header";
import { toast } from "react-toastify";
import _ from "lodash";
export default {
  transformData: (data) => {
    return data.map((module) => ({
      name: module.name,
      isActive: module.is_Active,
      type: "module",

      subRows: module.triggers.map((trigger) => ({
        triggerKey: trigger.trigger_Key,
        isActive: trigger.is_Active,
        type: "trigger",

        subRows: trigger.recipients.map((recipient) => ({
          recipientName: recipient.recipient_Id, // yahan API se name aa sakta hai
          recipientType: recipient.recipient_Type,
          type: "recipient",
        })),
      })),
    }));
  },
  searchData: (data, term) => {
    if (!term)
      return {
        filtered: data,
        expanded: { notifications: [], triggers: [], recipients: [] },
      };

    const lower = term.toLowerCase();
    const expandedIds = { notifications: [], triggers: [], recipients: [] };

    const filtered = data
      .map((module) => {
        let moduleMatch = module.name.toLowerCase().includes(lower);

        const triggers = module.triggers
          .map((trigger) => {
            let triggerMatch = trigger.trigger_Key
              .toLowerCase()
              .includes(lower);

            const recipients = (trigger.recipients || []).filter((r) =>
              r.recipient_Name.toLowerCase().includes(lower)
            );

            if (recipients.length > 0) {
              expandedIds.triggers.push(trigger.id); // expand trigger
              return { ...trigger, recipients };
            } else if (triggerMatch) {
              return { ...trigger };
            }

            return null;
          })
          .filter(Boolean);

        if (triggers.length > 0) {
          expandedIds.notifications.push(module.id);
          return { ...module, triggers };
        } else if (moduleMatch) {
          return { ...module };
        }

        return null;
      })
      .filter(Boolean);

    return { filtered, expanded: expandedIds };
  },
};
